module.exports = __webpack_public_path__ + "static/media/tap.4b9d82c7.png";